import * as styles from "./ComboboxValue.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Combobox as BaseCombobox } from "@base-ui/react/combobox";

import type { ComboboxValueProps } from "./Combobox.types";

export function ComboboxValue({
  className,
  ...props
}: ComboboxValueProps): JSX.Element {
  return (
    <span data-slot="combobox-value" className={clsx(styles.value, className)}>
      <BaseCombobox.Value {...props} />
    </span>
  );
}
